import React, { Fragment } from 'react'
import Yup from '../../../../helpers/custom-yup'
import AccordionSecondary from '../../../../components/accordion/accordion-secondary.component'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions'
import { BillingAddress } from '../../../../components/form-components'
import { bindActionCreators } from 'redux'
import FontAwesome from 'react-fontawesome'
import ReactTooltip from 'react-tooltip'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import {
	getGridWith3Col,
	StyledInputContainer,
	ContainerBenefit,
	ContainerBenfitType,
} from './styles.style'
import {
	CheckboxToggleInput,
	CPFInput,
	DateInput,
	EmailInput,
	NumberInput,
	PhoneInput,
	SelectInput,
	TextInput,
	RGInput,
	CNPJInput,
	StateRegistrationInput,
	AsyncSelectInput,
} from '../../../../components/form-components/inputs.component'
import Button from '../../../../components/buttons/buttons.component'
import ModalConfirmation from './../../../../components/modal/modal-confirmation.component'
import { MuvicardAdminService } from '../../../../services/muvicard-admin.service'
import { StyledButtons, StyledSeparatorOrangeLine } from './styles.style'
import { CardInput } from '.'
import { maskHelper } from '../../../../helpers/mask.helper'

const getSchema = () =>
	Yup.object().shape({
		name: Yup.string().name().required('Preencha o nome'),
		active: Yup.mixed().oneOf([true, false, null]),
		cpf: Yup.string().cpf().required('Informe o CPF'),
		rg: Yup.string().rg().required('Informe o RG'),
		birthday: Yup.string()
			.birthday()
			.required('Informe a data de nascimento'),
		phone: Yup.string().phone().required('Informe o telefone'),
		cardProposalId: Yup.string(),
		cardStatus: Yup.string(),
		oneClickBuy: Yup.string(),
		benefitActive: Yup.mixed().oneOf([true, false]),
		benefitTypeId: Yup.string().when('benefitActive', {
			is: true,
			then: Yup.string().required('Informe o tipo do benefício'),
			otherwise: Yup.string(),
		}),
		benefitCode: Yup.string().when('benefitActive', {
			is: true,
			then: Yup.string().required('Informe o código do benefício'),
			otherwise: Yup.string(),
		}),
		// TODO: Implementar validação de caregiver quando conseguir setar caregiver existente.
	})

class FormItemsComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			redefinePasswordModalIsOpen: false,
		}
	}

	componentDidMount() {
		if (this.refs.accordion) {
			this.refs.accordion.openAll()
		}
	}

	redefineClientPassword = () => {
		this.setState({
			redefinePasswordModalIsOpen: true,
		})
	}

	onRedefinePassword = (confirmed) => {
		this.setState({
			redefinePasswordModalIsOpen: false,
		})

		if (confirmed) {
			const { match } = this.props
			MuvicardAdminService.SendResetPasswordEmail(match.params.id)
		}
	}

	render() {
		const {
			activeRef,
			statusRef,
			nameRef,
			rgRef,
			emailRef,
			birthdayRef,
			phoneRef,
			originalLimitValueRef,
			match,
			values,
			cardInformations,
			companyNameRef,
			stateRegistrationRef,
			companyTradingNameRef,
			benefitActiveRef,
			benefitTypeIdRef,
			benefitCodeRef,
			caregiverRef,
			loadCargiverOptions,
			caregiverOptions,
		} = this.props

		const { benefitsOptions } = this.props

		const caregiverUserData = this.props.client.benefitsData.caregiver
		let isCaregiverRequired = false

		benefitsOptions.find((benefitOption) => {
			if (benefitOption.value == values.benefitTypeId) {
				isCaregiverRequired = benefitOption.isCaregiverRequired
			}
		})

		const { redefinePasswordModalIsOpen } = this.state

		const statusOptions = [
			{ value: 'Ativo', label: 'Ativo' },
			{ value: 'Bloqueado', label: 'Bloqueado' },
			{ value: 'Cancelado', label: 'Cancelado' },
			{ value: 'Inativo', label: 'Inativo' },
		]

		let arrSections = [
			{
				title: 'Dados iniciais',
				content: (
					<div style={getGridWith3Col(5)}>
						<StyledInputContainer style={{ gridArea: '1 / 1 / 2 / 3' }}>
							<TextInput
								elementRef={nameRef}
								id="name"
								label="Nome *"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<SelectInput
								elementRef={activeRef}
								id="active"
								placeholder="Selecione..."
								label="Situação *"
								options={[
									{ value: true, label: 'Ativo' },
									{ value: false, label: 'Inativo' },
								]}
								multi={false}
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<CPFInput
								disabled
								id="cpf"
								label="CPF *"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<NumberInput
								id="moveflexNumber"
								label="Número Muviflex"
								disabled
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<RGInput
								elementRef={rgRef}
								id="rg"
								label="RG *"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer style={{ gridArea: '4 / 1 / 5 / 4' }}>
							<EmailInput
								elementRef={emailRef}
								id="email"
								label="E-mail *"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer style={{ gridArea: '5 / 1 / 5 / 2' }}>
							<CNPJInput id="cnpj" label="CNPJ" {...this.props} />
						</StyledInputContainer>
						<StyledInputContainer style={{ gridArea: '5 / 4 / 5 / 2' }}>
							<StateRegistrationInput
								elementRef={stateRegistrationRef}
								id="stateRegistration"
								label="Inscrição Estadual"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer style={{ gridArea: '6 / 1 / 6 / 4' }}>
							<TextInput
								elementRef={companyNameRef}
								id="companyName"
								label="Razão Social"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer style={{ gridArea: '7 / 1 / 7 / 4' }}>
							<TextInput
								elementRef={companyTradingNameRef}
								id="companyTradingName"
								label="Nome Fantasia"
								{...this.props}
							/>
						</StyledInputContainer>
					</div>
				),
			},
			{
				title: 'Dados Complementares',
				content: (
					<div style={getGridWith3Col(3)}>
						<StyledInputContainer>
							<DateInput
								elementRef={birthdayRef}
								id="birthday"
								label="Data de nascimento *"
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<SelectInput
								id="gender"
								placeholder="Selecione..."
								label="Sexo *"
								disabled
								options={[
									{ value: 'F', label: 'Feminino' },
									{ value: 'M', label: 'Masculino' },
									{ value: 'O', label: 'Outros' },
								]}
								multi={false}
								{...this.props}
							/>
						</StyledInputContainer>
						<StyledInputContainer>
							<PhoneInput
								elementRef={phoneRef}
								id="phone"
								label="Telefone *"
								{...this.props}
							/>
						</StyledInputContainer>
					</div>
				),
			},
			{
				title: 'Endereço de cobrança',
				content: <BillingAddress clientId={match.params.id} />,
			},
			{
				title: 'Benefício',
				content: (
					<ContainerBenefit>
						<ContainerBenfitType>
							<div>
								<p>Ativar</p>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<CheckboxToggleInput
										elementRef={benefitActiveRef}
										id="benefitActive"
										{...this.props}
									/>
									<p
										style={{
											color: this.props.values.benefitActive
												? 'orange'
												: 'black',
											paddingLeft: '1rem',
										}}>
										{this.props.values.benefitActive ? 'Sim' : 'Não'}
									</p>
								</div>
							</div>
							<StyledInputContainer>
								<SelectInput
									elementRef={benefitTypeIdRef}
									id="benefitTypeId"
									placeholder="Selecione..."
									label="Benefício"
									options={benefitsOptions}
									multi={false}
									{...this.props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<TextInput
									elementRef={benefitCodeRef}
									id="benefitCode"
									label="Codigo Benefiário"
									{...this.props}
								/>
							</StyledInputContainer>
						</ContainerBenfitType>
						<StyledInputContainer>
							<AsyncSelectInput
								{...this.props}
								elementRef={caregiverRef}
								id="caregiver"
								label="Acompanhante"
								placeholder="Selecione..."
								loadOptions={loadCargiverOptions}
								disabled={!isCaregiverRequired}
								defaultOptions={caregiverOptions}
								defaultValue={
									caregiverUserData
										? {
												label: caregiverUserData.name,
												value: caregiverUserData.userId,
										  }
										: null
								}
							/>
						</StyledInputContainer>
					</ContainerBenefit>
				),
			},
		]

		const novidadeSection = {
			title: 'Novidades',
			content: (
				<div>
					<p>
						Aceito receber informações, dicas, pesquisa de satisfação e
						promoções do Muviflex por e-mail, torpedo, ligação telefônica
						e/ou whatsApp.
					</p>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}>
						<CheckboxToggleInput
							id="subscribedToNewsletter"
							{...this.props}
						/>
						<p style={{ paddingLeft: '1rem' }}>
							{this.props.values.subscribedToNewsletter ? (
								<span
									style={{
										color: PRIMARY_COLOR,
									}}>
									Sim
								</span>
							) : (
								'Não'
							)}
						</p>
					</div>
				</div>
			),
		}

		const cobrancaSection = {
			title: 'Dados de cobrança',
			content: (
				<div>
					<p>
						Aplicar validação Antifraude{' '}
						<FontAwesome
							name="info-circle"
							data-for="AntifraudTooltip"
							data-tip="true"
						/>
					</p>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}>
						<CheckboxToggleInput id="antifraud" {...this.props} />
						<p style={{ paddingLeft: '1rem' }}>
							{this.props.values.antifraud ? (
								<span
									style={{
										color: PRIMARY_COLOR,
									}}>
									Sim
								</span>
							) : (
								'Não'
							)}
						</p>
					</div>
					<br />
					<p>
						Cobrar taxa de conveniência{' '}
						<FontAwesome
							name="info-circle"
							data-for="ServiceChargeTooltip"
							data-tip="true"
						/>
					</p>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}>
						<CheckboxToggleInput id="serviceCharge" {...this.props} />
						<p style={{ paddingLeft: '1rem' }}>
							{this.props.values.serviceCharge ? (
								<span
									style={{
										color: PRIMARY_COLOR,
									}}>
									Sim
								</span>
							) : (
								'Não'
							)}
						</p>
					</div>

					<ReactTooltip id="AntifraudTooltip" effect="solid">
						Se inativo, a compra de passagens não passará pelo AntiFraud
						Konduto.
					</ReactTooltip>
					<ReactTooltip id="ServiceChargeTooltip" effect="solid">
						Se inativo, não será cobrada taxa de conveniência para nenhuma
						forma de pagamento na compra de passagens.
					</ReactTooltip>
				</div>
			),
		}

		const muvicardSection = {
			title: cardInformations ? 'Cartão Muvicard' : '',
			content: cardInformations ? (
				<div>
					<div className="card-inputs-container">
						<div className="card-inputs-wrapper">
							<SelectInput
								elementRef={statusRef}
								id="status"
								placeholder="Selecione..."
								label="Situação"
								options={statusOptions}
								multi={false}
								defaultValue={cardInformations.status}
								{...this.props}
							/>
							<NumberInput
								elementRef={originalLimitValueRef}
								id="limitValue"
								name="limitValue"
								label="Valor do limite *"
								{...this.props}
							/>
							<CardInput
								label="Valor do limite disponível"
								disabled
								id="cardLimitValue"
								name="limitValue"
								value={
									'R$ ' +
									maskHelper.applyBrazilianCurrency(
										cardInformations.limitValue
									)
								}
							/>
							<CardInput
								label="Dia de vencimento da fatura"
								disabled
								id="cardInvoiceExpirationDay"
								name="invoiceExpirationDay"
								value={cardInformations.invoiceExpirationDay}
							/>
							<CardInput
								label="Número da proposta"
								disabled
								id="cardProposalId"
								name="cardProposalId"
								value={
									cardInformations.cardProposalId
										? cardInformations.cardProposalId.padStart(6, '0')
										: ''
								}
							/>
							<CardInput
								label="Compra com 1 clique"
								disabled
								id="oneClickBuy"
								name="oneClickBuy"
								value={cardInformations.oneClickBuy ? 'Sim' : 'Não'}
							/>
							{cardInformations.statusNotes && (
								<div className="card-input-complete-row">
									Obs.: {cardInformations.statusNotes}
								</div>
							)}
						</div>
					</div>
					<StyledButtons className="buttons">
						<Button
							style={{ padding: '1.8rem 2rem' }}
							secondary
							type="button"
							onClick={this.redefineClientPassword}>
							Redefinir Senha
						</Button>
					</StyledButtons>
					<StyledSeparatorOrangeLine />
					<ModalConfirmation
						isOpen={redefinePasswordModalIsOpen}
						title={'Solicitar redefinição de senha'}
						onResult={this.onRedefinePassword}>
						Você confirma o envio de e-mail de redefinição de senha <br />
						para o usuário {values.name}
					</ModalConfirmation>
				</div>
			) : null,
		}

		arrSections.push(muvicardSection)

		//Verifica se tem permissão para alterar Novidades
		if (
			this.props.user.permissionTokens.some(
				(array) => array === '0F7287F894A341C0B8CEC7E031EFF9B4'
			)
		) {
			arrSections.push(novidadeSection)
		}

		//Verifica se tem permissão para alterar Dados de Cobrança
		if (
			this.props.user.permissionTokens.some(
				(array) => array === 'B16CEE3FBD10497EB1BF2D6BDCCE3298'
			)
		) {
			arrSections.push(cobrancaSection)
		}

		return (
			<AccordionSecondary
				ref={'accordion'}
				arrow={false}
				multiple
				items={arrSections}
			/>
		)
	}
}

const mapStateToProps = (state) => ({
	user: state.user,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...toastActions,
			...SiteCreators,
		},
		dispatch
	)

const connectedFormItemsComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(FormItemsComponent)
)
export { connectedFormItemsComponent as FormItemsComponent, getSchema }
